import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

export interface CurrencyDetailPageOptions extends PageOptionsBase {
}

export class CurrencyDetailPage extends PageBase<CurrencyDetailPageOptions> {

    public init() {
        //DetailPage.msApi = new MultiSelectApi('roles');
        //DetailPage.rolesInit = DetailPage.msApi.getSelectionValues();
    }

    public static showForm(field: string, focusField: string) {
        $(".multi-hide").hide();
        $(".multi-show").show();

        $(".multi-show").closest(".form-group").removeClass("gray");

        var label = "#lbl" + field;
        var frm = "#frm" + field;
        $(label).hide();
        $(frm).show();

        $(label).closest(".form-group").addClass("gray");

        if (focusField) {
            $('#' + focusField).focus();
        }
    }

    public static hideForm(field: string) {
        var label = "#lbl" + field;
        var frm = "#frm" + field;
        $(label).show();
        $(frm).hide();

        //DetailPage.msApi.setSelectionValues(DetailPage.rolesInit);

        $(label).closest(".form-group").removeClass("gray");
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Customers/CurrencyDetailPage.ts
 **/